export const FirebaseConfig = {
    apiKey: "AIzaSyAxMmzvKx1rVt9eH8UjzFiUVeF7bwUlkN0",
    authDomain: "veltonaccesos-113f7.firebaseapp.com",
    databaseURL: "https://veltonaccesos-113f7.firebaseio.com",
    projectId: "veltonaccesos-113f7",
    storageBucket: "veltonaccesos-113f7.appspot.com",
    messagingSenderId: "1009494387046"
};


// WEBPACK FOOTER //
// ./src/config/keys.js